import CustomInput from '@app/components/CustomInput'
import { RentalRateUnits } from '@app/models/enums'
import { IRentalRate, RentalRate } from '@app/models/RentalRate'
import { IGlobalConfigurationState } from '@app/store/modules/global'
import { bindFunctions } from '@app/utils/class'
import { humanize } from '@app/utils/formatting'
import * as React from 'react'
import { Input, InputGroup, InputGroupAddon } from 'reactstrap'

interface IRentalRateEditorProps {
  className?: string
  name?: string
  onChange: (newRentalRate: RentalRate) => void
  required?: boolean
  style?: React.CSSProperties
  value: IRentalRate
}

type RentalRateEditorProps = IRentalRateEditorProps & IGlobalConfigurationState

export default class RentalRateEditor extends React.PureComponent<
  RentalRateEditorProps
> {
  constructor(props: RentalRateEditorProps) {
    super(props)
    bindFunctions(this)
  }

  public render() {
    return (
      <div className={this.props.className} style={this.props.style}>
        <InputGroup>
          <InputGroupAddon addonType='prepend'>$</InputGroupAddon>
          <CustomInput
            type='number'
            name={this.props.name ? `${this.props.name}Rate` : undefined}
            required={this.props.required}
            step='0.01'
            value={this.props.value.rate}
            onChange={this._onChangeRate}
          />
          <Input
            type='select'
            name={this.props.name ? `${this.props.name}Units` : undefined}
            required={this.props.required}
            value={this.props.value.units}
            onChange={this._onChangeUnits}
          >
            {this.props.configuration.rentalRateUnits.map((key) => (
              <option key={key} value={key}>
                {humanize(key)}
              </option>
            ))}
          </Input>
        </InputGroup>
      </div>
    )
  }

  private _onChangeRate(e: number) {
    this.props.onChange(
      new RentalRate({
        rate: e,
        units: this.props.value.units,
      }),
    )
  }

  private _onChangeUnits(e: React.ChangeEvent<HTMLInputElement>) {
    this.props.onChange(
      new RentalRate({
        rate: this.props.value.rate,
        units: e.target.value as RentalRateUnits,
      }),
    )
  }
}
